import axiosInstanceWeb from "./axiosInstance.js";
import axiosInstanceMarvin from "./axiosInstanceMarvin.js";

// Lead-360 config used to be cached by the browser for 15 minutes via HTTP cache
// headers. Security asked us to drop those headers, so we cache the response in
// sessionStorage instead: per-tab, cleared on tab close, and bounded by the same
// 15-minute TTL. Keyed per leadTypeId since the config differs by lead type.
const LEAD360_CACHE_TTL_MS = 15 * 60 * 1000;
const lead360CacheKey = (leadTypeId) => `lead360:${leadTypeId || "default"}`;

const readLead360Cache = (key) => {
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return null;
    const { data, ts } = JSON.parse(raw);
    if (!ts || Date.now() - ts > LEAD360_CACHE_TTL_MS) {
      sessionStorage.removeItem(key);
      return null;
    }
    // Wrap so the caller can tell "cache hit" from a cached-but-falsy value.
    return { data };
  } catch {
    // Corrupt entry / storage unavailable — treat as a cache miss.
    return null;
  }
};

const writeLead360Cache = (key, data) => {
  try {
    sessionStorage.setItem(key, JSON.stringify({ data, ts: Date.now() }));
  } catch {
    // Private mode / quota exceeded — caching is best-effort, so ignore.
  }
};

export const apiGetLead360 = async () => {
  const leadTypeId = await window.lead360HelperUtils?.getLeadTypeId();
  const cacheKey = lead360CacheKey(leadTypeId);

  const cached = readLead360Cache(cacheKey);
  if (cached) {
    // Mirror the axios response shape the caller expects.
    return { status: 200, data: cached.data };
  }

  const response = await axiosInstanceWeb.get(
    `/lead-360/user?leadTypeId=${leadTypeId || "default"}`
  );
  if (response?.status === 200) {
    writeLead360Cache(cacheKey, response.data);
  }
  return response;
};

export const fetchImageUrl = async (key) => {
  try {
    const response = await axiosInstanceWeb.post(`/widgets/signedUrl`, {
      keys: [key],
    });
    return response.data.urls[0]; // Adjust the response to match the actual structure of your API response
  } catch (error) {
    console.error("Error fetching image URL:", error);
    return null; // Return null if there's an error
  }
};

export const fetchTaskCountApi = async (body) => {
  return await axiosInstanceMarvin.post(`Lead/Task/Get`, body);
};

export const fetchOpportunityCountApi = async (body) => {
  return await axiosInstanceMarvin.post(`Activity/Get`, body);
};

export const fetchActivityCountApi = async (body) => {
  return await axiosInstanceMarvin.post(`Activity/Get`, body);
};

export const fetchMailMergedContent = async (body) => {
  return await axiosInstanceMarvin.post(`/Connector/MailMergedContent/Get`, body);
};
